import { GENDERS } from 'dpl/shared/constants/breeder_app';

export const PERSONAL_PRONOUNS = {
  [GENDERS.MALE]: 'he',
  [GENDERS.FEMALE]: 'she'
};

export const POSSESSIVE_ADJECTIVES = {
  [GENDERS.MALE]: 'his',
  [GENDERS.FEMALE]: 'her'
};

export const QUESTION_NAMES = {
  LITTER_INFO: 'new_litter_info',
  LITTER_PARENTS: 'new_litter_parents',
  LITTER_PARENTS_SIRE: 'new_litter_sire',
  LITTER_PARENTS_DAM: 'new_litter_dam',
  LITTER_PRICING: 'new_litter_pricing',
  LITTER_PRICING_TYPE: 'new_litter_pricing_type',
  LITTER_PRICING_AMOUNT: 'new_Litter_pricing_amount',
  LITTER_PRICING_DEPOSIT: 'new_Litter_pricing_deposit',
  LITTER_PRICING_REVIEW: 'new_litter_pricing_review',
  LITTER_EXTRAS: 'new_litter_extras',
  LITTER_SOCIALIZATION: 'new_litter_socialization_enrichment',
  LITTER_PUPPY_FOOD: 'new_litter_food',
  LITTER_LOCATION: 'new_litter_location',
  LITTER_TRANSPORTATION: 'new_litter_transportation',
  LITTER_PUPPIES: 'new_litter_puppies',
  LITTER_PUPPY_DETAILS: 'new_litter_puppy_details',
  LITTER_ADULT_DOG_POLICY: 'new_litter_adult_dog_policy',
  LITTER_ATTESTATION: 'new_litter_attestation',
  LITTER_REVIEW: 'new_litter_review'
};

export const STEP_NAMES = {
  LITTER_INFO: 'Litter info',
  LITTER_PARENTS: 'Parents info',
  LITTER_PUPPIES: 'Puppy info',
  LITTER_PRICING: 'Pricing',
  LITTER_PRICING_TYPE: 'Litter pricing',
  LITTER_PRICING_AMOUNT: 'Listing price',
  LITTER_PRICING_DEPOSIT: 'Deposit',
  LITTER_PUPPY_FOOD: 'Puppy Food',
  LITTER_LOCATION: 'Location',
  LITTER_EXTRAS: 'Extras',
  LITTER_SOCIALIZATION: 'Socialization & Enrichment',
  LITTER_TRANSPORTATION: 'Transportation',
  LITTER_ATTESTATION: 'Review payment policy',
  LITTER_REVIEW: 'Review your profile'
};

export const PARENT_DESCRIPTION_PLACEHOLDER =
  "E.g., Bailey is gentle-natured and loves morning beach walks, playing fetch in the lake, and belly rubs. Their calm, patient demeanor makes them wonderful around kids. They're AKC registered with all recommended health clearances, including OFA certified hips.";

export const CURRENCY_VALIDATION_REGEX = new RegExp(/^[0-9]*\.?[0-9]{0,2}$/);

// new buyer app response flow
export const BUYER_APPLICATION_REVIEW_STEPS = {
  APPLICATION_DETAILS: 'APPLICATION_DETAILS',
  START_CONVERSATION: 'START_CONVERSATION',
  DECLINE_APPLICATION: 'DECLINE_APPLICATION'
};

export const FORM_CONVERSATION_MESSAGE_NAME =
  'conversation_message.message_text';
export const FORM_CONVERSATION_ATTACHMENTS =
  'conversation_message.conversation_attachments_attributes';
export const FORM_BUYER_APPLICATION_APPROVE = 'buyer_application.approve';
export const FORM_BUYER_APPLICATION_APPROVE_MESSAGING =
  'buyer_application.approve_messaging';
export const FORM_BUYER_APPLICATION_REJECT = 'buyer_application.reject';

export const LITTER_FORM_NAMES = {
  PRICE_RANGE_LOW: 'price_range_low',
  PRICE_RANGE_HIGH: 'price_range_high',
  ADULT_DOG_PRICE: 'puppies_attributes.0.price',
  IS_PRICE_FIXED: 'is_price_fixed',
  DEPOSIT: 'deposit',
  REQUIRES_DEPOSIT: 'requires_deposit',
  DEPOSIT_REFUND_POLICY: 'deposit_refund_policy'
};
